/** Regular expression for allowed password characters */
const allowedCharacters = /^[a-zA-Z0-9äöüßÄÖÜ!?=_\-+$]*$/;

/**
 * Filter function for paste events in password input fields
 * Prevents pasting of characters that don't match the allowed pattern
 * 
 * @param {React.ClipboardEvent<HTMLInputElement>} event - The paste event
 */
export function pasteFilter(event: React.ClipboardEvent<HTMLInputElement>) {
  const clipboardData = event.clipboardData.getData("text");

  if (!allowedCharacters.test(clipboardData)) {
    event.preventDefault();
  }
}

/**
 * Filter function for keydown events in password input fields
 * Prevents typing of characters that don't match the allowed pattern
 * Allows special keys like Backspace and Tab
 * 
 * @param {React.KeyboardEvent<HTMLInputElement>} event - The keydown event
 */
export function keyDownFilter(event: React.KeyboardEvent<HTMLInputElement>) {
  if (
    !allowedCharacters.test(event.key) &&
    event.key !== "Backspace" &&
    event.key !== "Tab"
  ) {
    event.preventDefault();
  }
}
